module.exports = __webpack_public_path__ + "static/img/图层 15.511180a0.png";